module.exports = __webpack_public_path__ + "img/Postmodernisme_Tove-Nilsen.41da64e1.jpg";